import React from 'react';
import clsx from 'clsx';
import { IProps } from './GlobalNotificationBlock.interface';
import './GlobalNotificationBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Icon from '@/elements/Icon/Icon.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';

const GlobalNotificationBlock: React.FC<IProps> = ({
    icon,
    text,
    buttons,
    alert = 'alert',
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper className={clsx('globalNotificationBlock', className)} {...blockWrapperProps} role={alert} aria-live={alert === 'alert' ? 'assertive' : 'polite'}>
            <ContentWrapper className='globalNotificationBlock__wrapper'>
                <ContentColumn className='globalNotificationBlock__content'>
                    {icon && (
                        <div className="globalNotificationBlock__icon-wrapper">
                            <Icon icon={icon} />
                        </div>
                    )}
                    {text && (
                        <div className="globalNotificationBlock__text-wrapper">
                            <Text html={text} />
                        </div>
                    )}
                    {buttons && buttons.length > 0 && (
                        <div className="globalNotificationBlock__button-wrapper">
                            {buttons.map((button, index) => (
                                <Button
                                    key={`globalNotificationBlock__button--${index}`}
                                    {...button}
                                    size='sm'
                                    className={clsx('globalNotificationBlock__button')}
                                />
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default GlobalNotificationBlock;

